// Shared anonymous visitor session ID. Persisted in localStorage so it's
// stable across reloads and is the SAME id used by /api/visits/track and the
// globe pin tracker — so listener favorites and visitor stats live under one
// identity per browser without ever asking the user to sign up.

import axios from "axios";

const VISIT_SESSION_KEY = "drr_visitor_session_id";

export function getOrCreateSessionId() {
  try {
    let id = localStorage.getItem(VISIT_SESSION_KEY);
    if (!id) {
      id =
        "v_" +
        Date.now().toString(36) +
        "_" +
        Math.random().toString(36).slice(2, 10);
      localStorage.setItem(VISIT_SESSION_KEY, id);
    }
    return id;
  } catch (e) {
    return "v_anon_" + Math.random().toString(36).slice(2, 10);
  }
}

export const VISIT_TRACKED_EVENT = "drr:visit-tracked";
let trackPromise = null;

// One /visits/track per page load, from any page. Notifies the globe when done.
export function trackVisit() {
  if (!trackPromise) {
    trackPromise = axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/visits/track`, {
        session_id: getOrCreateSessionId(),
      })
      .then((res) => {
        window.dispatchEvent(new CustomEvent(VISIT_TRACKED_EVENT, { detail: res.data }));
        return res.data;
      })
      .catch((e) => {
        trackPromise = null;
        throw e;
      });
  }
  return trackPromise;
}
